// ประเภทแทง 4 ตัว / 5 ตัว (huay-service docs/FOUR_FIVE_DIGIT_BETS.md) — ค่าคงที่กลางของ office
// ประเภทเดิม 1–8 ยังอ่านตามตำแหน่ง array ของแต่ละหน้าเหมือนเดิม · ประเภทใหม่อ่านตามรหัสจากที่นี่เท่านั้น
// รหัส: หลักสิบ = จำนวนหลัก · 41 4 ตัวบน · 42 4 ตัวโต๊ด · 51 5 ตัวบน · 52 5 ตัวโต๊ด
export const FOUR_TOP = 41
export const FOUR_TOD = 42
export const FIVE_TOP = 51
export const FIVE_TOD = 52

export const FOUR_FIVE_DIGIT_TYPES = [FOUR_TOP, FOUR_TOD, FIVE_TOP, FIVE_TOD]

// ชื่อเต็ม (ชุด "สามตัวบน") และชื่อสั้น (ชุด "3 ตัวบน") ให้เข้ากับป้ายเดิมของแต่ละหน้า
export const FOUR_FIVE_DIGIT_LABELS = {
  [FOUR_TOP]: 'สี่ตัวบน', [FOUR_TOD]: 'สี่ตัวโต๊ด', [FIVE_TOP]: 'ห้าตัวบน', [FIVE_TOD]: 'ห้าตัวโต๊ด',
}
export const FOUR_FIVE_DIGIT_SHORT_LABELS = {
  [FOUR_TOP]: '4 ตัวบน', [FOUR_TOD]: '4 ตัวโต๊ด', [FIVE_TOP]: '5 ตัวบน', [FIVE_TOD]: '5 ตัวโต๊ด',
}

// ยี่กีทุกห้องใช้อัตราจ่าย / เงื่อนไข / สวิตช์ 4/5 ตัวชุดเดียวกัน — ผลของ four-five-digit/access เก็บไว้ใต้รหัสเสมือนนี้
// (ตรงกับ FourFiveDigitRules.YeekeeId ฝั่ง server) · ห้องยี่กีเป็น ObjectId 24 ตัวอักษร หวยปกติเป็นรหัสสั้น
export const YEEKEE_ACCESS_KEY = 'yeekee'
export const isYeekeeRoomId = huayId => String(huayId || '').length === 24

// ประเภทใหม่ของหวยหรือห้องยี่กีหนึ่งรายการ จากผลของ four-five-digit/access (หรือ editable)
export const fourFiveDigitAccessOf = (access, huayId) => (access || {})[isYeekeeRoomId(huayId) ? YEEKEE_ACCESS_KEY : huayId] || []

// สิทธิ์ของหวยปกติทุกหวย ไม่รวมยี่กี — สำหรับหน้าที่รวมทุกหวยแต่ไม่มียี่กีในรายการ
export const huayAccessLists = access => Object.entries(access || {})
  .filter(([huayId]) => huayId !== YEEKEE_ACCESS_KEY)
  .map(([, types]) => types)

export const isFourFiveDigit = type => FOUR_FIVE_DIGIT_TYPES.includes(Number(type))
export const isFourFiveDigitTod = type => Number(type) === FOUR_TOD || Number(type) === FIVE_TOD
export const fourFiveDigitLength = type => Math.floor(Number(type) / 10)

// ป้ายของประเภท: ประเภทเดิมตามตำแหน่งในชุดป้ายของหน้านั้น · ประเภทใหม่ตามรหัส
export const betTypeLabel = (type, legacyLabels, short = false) => {
  const code = Number(type)
  if (isFourFiveDigit(code)) return (short ? FOUR_FIVE_DIGIT_SHORT_LABELS : FOUR_FIVE_DIGIT_LABELS)[code]
  return (legacyLabels || [])[code - 1] || String(type)
}

// ตรวจเลขของประเภทใหม่ · คืนข้อความผิดพลาด หรือ '' ถ้าผ่าน (ตรงกับกติกาฝั่ง server)
export const fourFiveDigitNumberError = (type, number) => {
  const length = fourFiveDigitLength(type)
  const value = String(number || '')
  if (!new RegExp(`^\\d{${length}}$`).test(value)) return `ต้องเป็นตัวเลข ${length} หลัก`
  if (isFourFiveDigitTod(type) && new Set(value).size === 1) return 'โต๊ดไม่รับเลขที่ทุกหลักเหมือนกัน'
  return ''
}

// ทุกรูปแบบการสลับหลักที่ไม่ซ้ำกัน เรียงจากน้อยไปมาก (4 ตัว สูงสุด 24 · 5 ตัว สูงสุด 120)
export const digitPermutations = number => {
  const digits = [...String(number)].sort()
  const result = []
  for (;;) {
    result.push(digits.join(''))
    let i = digits.length - 2
    while (i >= 0 && digits[i] >= digits[i + 1]) i -= 1
    if (i < 0) return result
    let j = digits.length - 1
    while (digits[j] <= digits[i]) j -= 1
    const swap = digits[i]
    digits[i] = digits[j]
    digits[j] = swap
    const tail = digits.splice(i + 1).reverse()
    digits.push(...tail)
  }
}

// หน้าอัตรากลาง / เงื่อนไขของ master: เติมแถวว่าง (ไม่มี id) ของประเภทใหม่ที่หวยนี้เปิดได้แต่ยังไม่มีแถว
// server สร้างแถวให้ตอนบันทึก (PUT rate/reward · rate/condition)
export const withFourFiveDigitRows = (rows, allowedTypes, blankRow) => {
  const list = Array.isArray(rows) ? rows : []
  const existing = new Set(list.map(v => Number(v.type)))
  const missing = (allowedTypes || []).filter(type => isFourFiveDigit(type) && !existing.has(type))
  return missing.length === 0 ? list : list.concat(missing.map(type => ({ ...blankRow, type })))
}

// แถวของประเภทใหม่ที่ agent นี้ใช้ไม่ได้ต้องไม่โผล่ในหน้าตั้งค่า (allowed = ประเภทใหม่ที่ใช้ได้ของหวยนี้)
export const visibleRateRows = (rows, allowedTypes) => (Array.isArray(rows) ? rows : [])
  .filter(row => !isFourFiveDigit(row.type) || (allowedTypes || []).includes(Number(row.type)))

const RATE_KEYS = ['normal', 'vip1', 'vip2', 'vip3', 'vip4']
const CONDITION_KEYS = ['min', 'maxPerTime', 'maxPerNumber']

// ตอนบันทึกหน้าอัตรากลาง: แถวใหม่ที่ยังไม่แตะ = ไม่ส่ง (ไม่สร้างแถวที่ master ไม่ได้ตั้งใจ)
// แถวใหม่ที่แตะแล้วต้องมีเงื่อนไขการแทงครบ — server ไม่รับแถวที่ขั้นต่ำ/สูงสุดเป็น 0 และแถวที่สร้าง
// โดยไม่มีเงื่อนไขจะทำให้บันทึกเงื่อนไขของทั้งหวยไม่ผ่านในครั้งถัดไป
export const splitNewRateRows = rows => {
  const incomplete = []
  const kept = (rows || []).filter(row => {
    if (row.id || !isFourFiveDigit(row.type)) return true
    const touched = RATE_KEYS.concat(CONDITION_KEYS).some(key => Number(row[key] || 0) !== 0)
    if (!touched) return false
    if (CONDITION_KEYS.every(key => Number(row[key] || 0) > 0)) return true
    incomplete.push(Number(row.type))
    return false
  })
  return { rows: kept, incomplete }
}

export const BLANK_RATE_ROW = {
  normal: 0, vip1: 0, vip2: 0, vip3: 0, vip4: 0, min: 0, maxPerTime: 0, maxPerNumber: 0,
}

// หน้าตั้งค่า: ประเภทใหม่ที่เห็นได้ (เปิดโหมดแล้ว) แต่ยังไม่ติ๊กเปิดในหวยนั้น แก้ค่าไม่ได้ · ประเภทเดิมแก้ได้เสมอ
export const isLockedFourFiveDigit = (type, editableTypes) => isFourFiveDigit(type)
  && !(editableTypes || []).includes(Number(type))
